import { addScript } from '../../lib/add-script';

declare const window: Window & { dataLayer: IArguments[]; gtag: (...args: unknown[]) => void };

interface GTagNoOpConfig {
    enabled: false;
}
interface GTagEnabledConfig {
    enabled: true;
    key: string;
}

export type GTagConfig = GTagEnabledConfig | GTagNoOpConfig;
export type GTagLoadFunction = () => void;

const noOpGTagLoader: GTagLoadFunction = () => {return;};

const createDataLayer = (): void => {
    window.dataLayer = window.dataLayer || [];
};

const createGTagFunction = (key: string): void => {
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function (..._any: unknown[]):void {window.dataLayer.push(arguments);};
    window.gtag('js', new Date());
    window.gtag('config', key);
};

const createGTagLoader = (key: string): () => void => 
    () => addScript(`https://www.googletagmanager.com/gtag/js?id=${key}`);

export const setupGTag = (config: GTagConfig): GTagLoadFunction => {
    createDataLayer();
    if (config.enabled) {
        createGTagFunction(config.key);
        return createGTagLoader(config.key);
    }
    return noOpGTagLoader;
};